// #78/#82: Der gemeinsame Freitextfilter-Baustein — vorher fuenfmal als Kopie unterwegs (E2E-,
// Glossar-, Testdaten-, Simplifications-Tab, Prozessbaum) und bereits divergiert (siehe Task-3-
// Brief). `matchesQuery` ist bewusst simpel gehalten: getrimmt, kleingeschrieben, `includes` —
// kein Fuzzy-Matching, keine Gewichtung, keine Relevanz-Sortierung (Entscheidung aus #78, gilt
// unveraendert weiter).

/**
 * Prueft, ob einer der uebergebenen Feldwerte den Suchbegriff enthaelt (Teiltreffer, nicht nur
 * Praefix — genau daran scheiterte der 204er-`<select>` aus #82).
 *
 * Ein leerer (oder nur aus Leerzeichen bestehender) Suchbegriff trifft ALLES: das ist der
 * Ausgangszustand jeder Trefferliste ("keine Suche aktiv"), keine Fehlbedienung. `null`/
 * `undefined`-Felder (z. B. optionale Notizen) zaehlen wie ein leerer String mit — sie treffen
 * also nie einen nicht-leeren Suchbegriff, blockieren aber auch nichts.
 */
export function matchesQuery(query: string, ...fields: (string | null | undefined)[]): boolean {
  const trimmed = query.trim().toLowerCase();
  if (trimmed === '') return true;
  return fields.some((field) => (field ?? '').toLowerCase().includes(trimmed));
}
